export const PALETTE = [
 "#1976d2","#388e3c","#7b1fa2","#c62828",
 "#00838f","#f57f17","#2e7d32","#6a1b9a"
];

export const avatarBg = (name: string) =>
  PALETTE[name.charCodeAt(0) % PALETTE.length];

export const initials = (name: string) =>
  name.split(" ").slice(0,2).map(w=>w[0]).join("").toUpperCase();

export const fmt = (date: Date) =>
  date.toLocaleTimeString([], { hour:"2-digit", minute:"2-digit" });

export const humanSize = (bytes:number)=>{
 if(bytes<1024) return `${bytes} B`;
 if(bytes<1048576) return `${(bytes/1024).toFixed(1)} KB`;
 return `${(bytes/1048576).toFixed(1)} MB`;
};